var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAhrefs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 206,
    viewBox: "0 0 806 206",
    width: 806,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h806v206h-806z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.77 81.03h79.32v22.14l-29.83 2.28c-48.17 3.57-63.26 16.26-63.26 51.74v7.16c0 26.02 18.36 41.64 46.55 41.64 22.28 0 35-5.21 50.81-21.24h2.55v16.93h31.79v-155.21h-117.93zm79.31 74.85c-9.72 9.77-24.58 16.28-36.71 16.28-13.11 0-18.67-4.89-18.36-15.62.33-14.98 5.83-18.55 31.11-20.83l23.92-2.28z",
    fill: "#f80"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#054ada"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m758.81 109.02-23.61-2.32c-13.11-1.29-16.39-4.56-16.39-14.96 0-11.72 4.59-14.65 22.95-14.65 16.39 0 20.98 2.61 23.34 13.67h36.71c-.99-37.11-12.46-46.53-58.02-46.53-49.82 0-62.22 9.42-62.22 47.51 0 34.75 9.18 44.25 46.22 47.82l19.35 1.93c17.36 1.64 21.62 4.89 21.62 15.31 0 12.68-5.25 15.95-26.54 15.95-18.69 0-23.61-2.93-24.58-14.98h-37.16c.97 38.4 12.78 48.17 59.99 48.17 52.5 0 65.55-10.41 65.55-52.73 0-31.51-9.51-40.62-47.19-44.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.14 111.96c0-50.2-17.38-67.69-67.2-67.69s-68.51 22.76-68.51 79.39c0 61.78 17.05 82.34 72.12 82.34 39.65 0 56.39-12.03 61.93-45.89h-37.68c-4.26 10.42-8.85 12.7-24.91 12.7-24.25 0-30.49-6.83-31.79-35.79h93.34c1.61-8.26 2.51-16.64 2.7-25.06zm-95.71-5.54c.33-21.8 9.18-29.94 30.14-29.94s28.2 8.15 28.86 29.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.92 46.55h-61.29v-46.55h-39.01v201.77h39.01v-120.42h55.71v120.42h39.01v-123.66h-33.43v-31.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m584.09 53.36v148.41h39.01v-122.09h46.86v-33.13h-46.86v-4.25c.33-9.11 2.62-11.7 10.17-11.7h42.6v-30.6h-45.89c-31.13 0-45.89 9.44-45.89 53.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.18 201.77h39.01v-118.79h58.02v-36.43h-97.03z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrefs);
export default __webpack_public_path__ + "static/media/ahrefs.2571801613bc694c0adb9558c320779d.svg";
export { ForwardRef as ReactComponent };